module.exports = __webpack_public_path__ + "resource/img/notFind.3fd1c08e.png";